import styled from '@emotion/styled'
import FormGroup from '@mui/material/FormGroup'
import _FormControl from '../FormControl'

export const CheckboxGroup = styled(FormGroup)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const FormControl = styled(_FormControl)`
  > label {
    transform: translate(0, -1.5px) scale(0.75);
    + .MuiFormGroup-root {
      margin-top: 16px;
    }
  }
`
